import styled from 'styled-components';

export const HRC = styled.span``;
